import { IPoolTemplateType } from "@services/pooltemplates";

export enum ActionPoolTemplatesTypes {
  ACTION_SET_POOL_TEMPLATES = "ACTION_SET_POOL_TEMPLATES",
  ACTION_ADD_POOL_TEMPLATE = "ACTION_ADD_POOL_TEMPLATE",
  ACTION_DELETE_POOL_TEMPLATE = "ACTION_DELETE_POOL_TEMPLATE",
}

export interface ActionPoolTemplatesBase {
  type: ActionPoolTemplatesTypes;
  payload?: unknown;
}

export interface ActionSetPoolTemplates extends ActionPoolTemplatesBase {
  payload: IPoolTemplateType[];
}

export interface ActionAddPoolTemplates extends ActionPoolTemplatesBase {
  payload: IPoolTemplateType;
}

export interface ActionDeletePoolTemplates extends ActionPoolTemplatesBase {
  payload: IPoolTemplateType["Id"];
}

export const setPoolTemplates = (
  payload: ActionSetPoolTemplates["payload"]
): ActionSetPoolTemplates => {
  return {
    type: ActionPoolTemplatesTypes.ACTION_SET_POOL_TEMPLATES,
    payload,
  };
};

export const addPoolTemplate = (
  payload: ActionAddPoolTemplates["payload"]
): ActionAddPoolTemplates => {
  return {
    type: ActionPoolTemplatesTypes.ACTION_ADD_POOL_TEMPLATE,
    payload,
  };
};

export const deletePoolTemplate = (
  payload: ActionDeletePoolTemplates["payload"]
): ActionDeletePoolTemplates => {
  return {
    type: ActionPoolTemplatesTypes.ACTION_DELETE_POOL_TEMPLATE,
    payload,
  };
};
